import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo en Gemoterapia?',
  a: 'Especialmente si recién empezás. El sistema te da la estructura terapéutica desde la primera sesión. No tenés que improvisar ni esperar años de experiencia. El Tomo I es tu guía de fundamentos y cristales, el Tomo II son tus protocolos listos para aplicar, el Tomo III te enseña a proteger tu propio campo y el Tomo IV te da el mapa completo del sistema de chakras.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra recibís un correo con el enlace de descarga. El acceso es instantáneo. Si tenés algún problema, escribinos a soportelumenakasha@gmail.com o por WhatsApp y lo resolvemos en el día.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No es necesario. El material está diseñado para usarse en tablet, computadora o celular. Si preferís tenerlo impreso para tu consultorio, podés imprimir solo las fichas, mapas y checklists que más uses en sesión.'
}, {
  q: '¿Qué lo diferencia de un curso de Gemoterapia?',
  a: 'Un curso te da conocimiento teórico. El Mega Pack te da un sistema listo para aplicar. No es teoría: son protocolos completos, fichas, mapas de cristales, herramientas de protección y recursos profesionales que podés usar desde la próxima sesión sin esperar a terminar un curso de meses.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días desde la compra para revisarlo completo. Si sentís que no es lo que esperabas, escribinos y te devolvemos el dinero sin preguntas. Confiamos en el valor de lo que creamos.'
}, {
  q: '¿Puedo compartirlo con otras terapeutas?',
  a: 'El material es de uso personal y profesional exclusivo. Cada terapeuta debe tener su propia licencia de uso. Compartirlo es una violación de derechos de autoría y perjudica directamente la posibilidad de seguir creando material de calidad para la comunidad holística.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-65" data-mp="2fwan0c458gxp">
      <div className="mb-12 text-center" data-id="element-66" data-mp="2fxdaea29c18v">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-purpleDark md:text-4xl" data-id="element-67" data-mp="2axr0a9hq714a">
          <span className="mr-3" data-id="element-68" data-mp="38l98nj7h617r">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-69" data-mp="33melk52h5qhu">
        {faqs.map((faq, index) => <div key={faq.q} className="glass-panel overflow-hidden rounded-2xl border-brand-purple/20" data-id="element-70" data-mp="33kbnqyv2yt2k" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors hover:bg-brand-surfaceLight focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-goldBright" data-id="element-71" data-mp="2ypeh1yl9wvsu">
              <span className="pr-8 text-sm font-semibold text-brand-purpleDark md:text-base" data-id="element-72" data-mp="3urtstc4c9fvv">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-73" data-mp="2nrkiocdm0fu" />
            </button>
            <AnimatePresence initial={false} data-id="element-74" data-mp="chrx1b9zm7yl">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} data-id="element-75" data-mp="hh4fljttssvd">
                  <p className="border-t border-brand-purple/15 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-76" data-mp="vdq80fax9pie">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}